import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class ProceduresAwarenessOverlay {
  public dialogRef: MatDialogRef<any>;

  constructor(public dialog: MatDialog) {}

  public open(component: any): MatDialogRef<any> | void {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(component, {
        panelClass: 'procedures-awareness-overlay',
        position: { bottom: '16px' },
      });
    }
  }

  public close(): void {
    this.dialog.closeAll();
  }
}
